<template>
  <v-breadcrumbs v-bind:items="itemsTranslations" class="breadcrumbG letter-big"></v-breadcrumbs>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
  mixins: [apiCalls],
  props: [ "event" ],
  data() {
    return {
      routes: [],
      breadcrumbItems: [],
      breadcrumbSelected: undefined
    };
  },
  mounted() {
    this.$emit('changeBand', {index: 'bandBreadCrumbMounted',value: true});
    this.fillRoutes();
    this.dinamicItemsBreadcrumbs();
  },
  computed: {
    itemsTranslations: function() {
      this.fillRoutes();
      this.dinamicItemsBreadcrumbs();
      return this.breadcrumbItems;
    },
    eventId: function() {
      return (this.event !== null && this.event !== undefined) ? this.event.id : 0;
    }
  },
  methods: {
    fillRoutes: function() {
      this.routes = [
        {
          text: this.$t("breadcrumb.dashboard"),
          name: "PromoterDashboard",
          breadcrumb: []
        },
        {
          text: this.$t("breadcrumb.profile"),
          path: "profile",
          name: "Profile",
          breadcrumb: [ "Profile" ]
        },
        {
          text: this.$t("breadcrumb.events"),
          path: "eventList",
          name: "EventList",
          breadcrumb: ["EventList"]
        },
        {
          text: this.$t("breadcrumb.event-details"),
          path: "eventDetails",
          name: "eventDetails",
          breadcrumb: ["EventList", "eventDetails"]
        },
        {
          text: this.$t("breadcrumb.practice"),
          path: "practice",
          name: "practice",
          breadcrumb: ["EventList", "practice"]
        },
        {
          text: this.$t("breadcrumb.event-create"),
          name: "EventCreate",
          breadcrumb: [ "EventList", "EventCreate"]
        },
        {
          text: this.$t("breadcrumb.clone-event"),
          name: "CloneEvents",
          breadcrumb: [ "EventList", "CloneEvents"]
        },
        {
          text: this.$t("breadcrumb.registrations"),
          name: "Registration",
          breadcrumb: ["EventList", "eventDetails", "Registration"]
        },
        {
          text: this.$t('breadcrumb.resgitration-setup'),
          name: "RegistrationSetup",
          breadcrumb: [ "EventList", "eventDetails", "Registration", "RegistrationSetup" ]
        },
        {
          text: this.$t("breadcrumb.new-registrant"),
          name: "CreateRegistrant",
          breadcrumb: ["EventList", "eventDetails", "Registration", "CreateRegistrant"],
        },
        {
          text: this.$t("breadcrumb.import-registrants"),
          name: "ImportRegistrants",
          breadcrumb: ["EventList", "eventDetails", "Registration", "ImportRegistrants"],
        },
        {
          text: this.$t('breadcrumb.delete-all-registrants'),
          name: "DeleteAllRegistrants",
          breadcrumb: ["EventList", "eventDetails", "Registration", "DeleteAllRegistrants"]
        },
        {
          text: this.$t('breadcrumb.wait-list'),
          name: "WaitList",
          breadcrumb: ["EventList", "eventDetails", "Registration", "WaitList"]
        },
        {
          text: this.$t("breadcrumb.validate-ama"),
          name: "ValidateAma",
          breadcrumb: ["EventList", "eventDetails", "Registration", "ValidateAma"]
        },
        {
          text: this.$t("breadcrumb.classes"),
          name: "EventClasses",
          breadcrumb: ["EventList", "eventDetails", "EventClasses"]
        },
        {
          text: this.$t("breadcrumb.class-linked"),
          name: "LinkedClasses",
          breadcrumb: ["EventList", "eventDetails", "EventClasses", "LinkedClasses"]
        },
        {
          text: this.$t("breadcrumb.class-create"),
          name: "CreateClasses",
          breadcrumb: ["EventList", "eventDetails", "EventClasses", "CreateClasses"]
        },
        {
          text: this.$t("breadcrumb.class-import"),
          name: "ImportClasses",
          breadcrumb: ["EventList", "eventDetails", "EventClasses", "ImportClasses"]
        },
        {
          text: this.$t('breadcrumb.class-edit'),
          name: "EditClasses",
          breadcrumb: [ "EventList", "eventDetails", "EventClasses", "EditClasses"]
        },
        {
          text: this.$t("breadcrumb.brands"),
          name: "EventBrands",
          breadcrumb: [ "EventList", "eventDetails", "EventBrands"]
        },
        {
          text: this.$t("breadcrumb.brand-import"),
          name: "ImportBrands",
          breadcrumb: [ "EventList", "eventDetails", "EventBrands", "ImportBrands" ]
        },
        {
          text: this.$t("breadcrumb.start-grid"),
          name: "StartGrids",
          breadcrumb: [ "EventList", "eventDetails", "StartGrids" ]
        },
        {
          text: this.$t("breadcrumb.my-laps"),
          name: "MyLaps",
          breadcrumb: ["EventList", "eventDetails", "MyLaps"]
        },
        {
          text: this.$t("breadcrumb.sport-tags"),
          name: "SportTags",
          breadcrumb: ["EventList", "eventDetails", "SportTags"]
        },
        {
          text: this.$t("breadcrumb.race-timer"),
          name: "RaceTimer",
          breadcrumb: [ "EventList", "eventDetails", "RaceTimer"]
        },
        {
          text: this.$t("breadcrumb.westhold"),
          name: "Westhold",
          breadcrumb: ["EventList", "eventDetails", "Westhold"],
        },
        {
          text: this.$t("breadcrumb.reports"),
          path: "reportsDashboard",
          name: "reportsDashboard",
          breadcrumb: ["reportsDashboard"]
        },
        {
          text: this.$t("breadcrumb.series"),
          path: "seriesDashboard",
          name: "seriesDashboard",
          breadcrumb: ["seriesDashboard"]
        },
        {
          text: this.$t("breadcrumb.race-edit"),
          name: "raceEdit",
          breadcrumb: ["EventList", "eventDetails", "RaceList", "raceDetails", "raceEdit"],
          type: "Race"
        },
        {
          text: this.$t("breadcrumb.race-edit"),
          name: "SectionEditor",
          breadcrumb: ["EventList", "eventDetails", "RaceList", "raceDetails", "SectionEditor"],
          type: "Race"
        },
        {
          text: this.$t("breadcrumb.new-participant"),
          name: "NewParticipant",
          breadcrumb: ["EventList", "eventDetails", "RaceList", "raceDetails", "NewParticipant"],
          type: "Race"
        },
        {
          text: this.$t("breadcrumb.participant-scores"),
          name: "ParticipantScores",
          breadcrumb: ["EventList", "eventDetails", "RaceList", "raceDetails", "ParticipantScores"],
          type: "Race"
        },
        {
          text: this.$t("breadcrumb.delete-class-scores"),
          name: "DeleteClassScore",
          breadcrumb: ["EventList", "eventDetails", "RaceList", "raceDetails", "DeleteClassScore"],
          type: "Race"
        },
        {
          text: this.$t("breadcrumb.results"),
          name: "Results",
          breadcrumb: ["EventList", "eventDetails", "RaceList", "raceDetails", "Results"],
          type: "Race"
        },
        {
          text: this.$t("breadcrumb.quick-scores"),
          name: "QuickScore",
          breadcrumb: ["EventList", "eventDetails", "RaceList", "raceDetails", "QuickScore"],
          type: "Race"
        },
        {
          text: this.$t("breadcrumb.add-dnf-participants"),
          name: "AddDNFParticipants",
          breadcrumb: ["EventList", "eventDetails", "RaceList", "raceDetails", "AddDNFParticipants"],
          type: "Race"
        },
        {
          text: this.$t("breadcrumb.clear-all-scores"),
          name: "ClearAllScores",
          breadcrumb: ["EventList", "eventDetails", "RaceList", "raceDetails", "ClearAllScores"],
          type: "Race"
        },
        {
          text: this.$t("breadcrumb.import-scores-from-race"),
          name: "ImportScoresFromRace",
          breadcrumb: ["EventList", "eventDetails", "RaceList", "raceDetails", "ImportScoresFromRace"],
          type: "Race"
        },
        {
          text: this.$t("breadcrumb.races"),
          name: "RaceList",
          breadcrumb: [ "RaceList" ],
        },
        {
          text: this.$t("breadcrumb.races-create"),
          name: "RacesCreate",
          breadcrumb: (this.$route.name == "RacesCreate" && this.$route.params.id !== undefined) 
                        ? [ "EventList", "eventDetails", "RaceList", "RacesCreate" ] 
                        : [ "RaceList", "RacesCreate"],
          type: (this.$route.name == "RacesCreate" && this.$route.params.id !== undefined) ? "Race" : undefined
        },
        {
          text: this.$t("breadcrumb.import-race"),
          name: "ImportRaces",
          breadcrumb: [ "RaceList", "ImportRaces"],
          type: "Race"
        },
        {
          text: this.$t('breadcrumb.race-details'),
          name: "raceDetails",
          breadcrumb: [ "EventList", "eventDetails", "RaceList", "raceDetails" ],
          type: "Race"
        },
        {
          text: this.$t('breadcrumb.phone-monitor'),
          name: "PhoneMonitor",
          breadcrumb: [ "EventList", "eventDetails", "RaceList", "raceDetails", "PhoneMonitor" ],
          type: "Race"
        },
        {
          text: this.$t("breadcrumb.race-classes-setup"),
          name: "RaceClassesSetup",
          breadcrumb: ["EventList", "eventDetails", "RaceList", "raceDetails", "RaceClassesSetup"],
          type: "Race"
        },
        {
          text: this.$t("breadcrumb.race-scoring-parameters"),
          name: "RaceScoringParameters",
          breadcrumb: ["EventList", "eventDetails", "RaceList", "raceDetails", "RaceScoringParameters"],
          type: "Race"
        },
        {
          text: this.$t("breadcrumb.race-participants-setup"),
          name: "RaceParticipantsSetup",
          breadcrumb: ["EventList", "eventDetails", "RaceList", "raceDetails", "RaceParticipantsSetup"],
          type: "Race"
        },
        {
          text: this.$t("breadcrumb.race-list"),
          name: "EventRaceList",
          breadcrumb: [ "EventList", "eventDetails", "EventRaceList" ]
        },
        {
          text: this.$t("breadcrumb.race-images"),
          name: "EventRaceImages",
          breadcrumb: [ "EventList", "eventDetails", "EventRaceImages"]
        },
        {
          text: this.$t("breadcrumb.advance-settings"),
          name: "EventRaceAdvanceSettings",
          breadcrumb: [ "EventList", "eventDetails", "EventRaceAdvanceSettings" ]
        },
        {
          text: this.$t("breadcrumb.serie-details"),
          name: "SerieDetails",
          breadcrumb: [ "seriesDashboard", "SerieDetails" ]
        },
        {
          text: this.$t("breadcrumb.serie-results"),
          name: "SerieResults",
          breadcrumb: [ "seriesDashboard", "SerieResults" ]
        },
        {
          text: this.$t("breadcrumb.pricing"),
          name: "Pricing",
          breadcrumb: [ "EventList", "eventDetails", "Pricing" ]
        },
        {
          text: this.$t("breadcrumb.registered-spectator"),
          name: "RegisteredSpectator",
          breadcrumb: [ "EventList", "eventDetails", "RegisteredSpectator" ]
        }, {
          text: this.$t("breadcrumb.import-event"),
          name: "ImportEventOld",
          breadcrumb: [ "EventList", "ImportEventOld" ]
        }
      ];
    },
    dinamicItemsBreadcrumbs: function () {
      var items = [
        {
          text: this.$t("breadcrumb.dashboard"),
          disabled: false,
          href: this.$router.resolve("/dashboard").href
        }
      ];

      let breadcrumb = this.routes.filter(r => {
        return this.$route.name === r.name;
      });
      if(breadcrumb.length > 0) 
        this.breadcrumbSelected = breadcrumb[0]; 
      else {
        this.breadcrumbSelected = undefined;
      }
      
      if (
        breadcrumb.length > 0 &&
        breadcrumb[0].breadcrumbCustom !== undefined
      ) {
        let _items = items.concat(breadcrumb[0].breadcrumbCustom);
        this.breadcrumbItems = _items;
        return;
      }

      let _items =
        breadcrumb.length > 0
          ? breadcrumb[0].breadcrumb.map(elem => {
              let fElem = this.routes.filter(r => {
                return r.name === elem;
              })[0];

              let params = {};
              let eventId = null;
              let raceId = null;
              if(breadcrumb[0].type == "Race") {
                raceId = this.$route.params.id;
                eventId = this.eventId;
              } else 
                eventId = this.$route.params.id;
              
              if(fElem.type == "Race") 
                params = { id: raceId };
              else 
                params = { id: eventId };

              return {
                text: fElem.text,
                disabled: false,
                href: this.$router.resolve({ name: fElem.name, params }).href
              };
            })
          : [];
      items = this.breadcrumbSelected ? items.concat(_items) : [];
      if (items.length > 0) items[items.length - 1].disabled = true;

      this.breadcrumbItems = items;
    }
  }
};
</script>

<style scope>
.breadcrumbG a:not(.v-breadcrumbs__item--disabled) {color: var(--v-primary-darken2) !important;}
.breadcrumbG a.v-breadcrumbs__item--disabled {color: var(--v-primary-base) !important;}
@media screen and (min-width: 800px) {
  .letter-big a {font-size: 1.2rem;}
}
@media screen and (min-width: 351px) and (max-width: 799px){
  .letter-big a {font-size: 1.1rem;}
}
@media screen and (max-width: 350px) {
  .letter-big a {font-size: 13px;}
}
</style>
